module.exports = __webpack_public_path__ + "img/parachute.f5c6526.png";